import { CountLinkParams } from "../../typings";
import { getCountLinkParams } from "../getCountLinkParams";

export const getOutrightCountLinkParams = (props): CountLinkParams => {
    return { ...getCountLinkParams(props), ...{ count: props.markets[0].selections.length } }
}